import {
  UPDATE_ZOOM_COURSE_ID,
  UPDATE_ZOOM_HOST,
  LOAD_ZOOM_EVENTS_DATA,
  UPDATE_SELECTED_ZOOM_EVENTS,
  UPDATE_ZOOM_SCHEDULERS,
  UPDATE_ZOOM_COURSE_DETAILS
} from '../constants/action-types'

const defaultState = {
  courseId: '',
  courseDetails: {},
  zoomHost: '',
  coHost: '',
  selectedEventIds: {
    data: []
  },
  updatedBy: '',
  events: {
    data: [],
    pageCount: 0
  },
  schedulers: []
  // tableRefresh:{
  //     ref:'',
  //     refresh:true
  // }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case LOAD_ZOOM_EVENTS_DATA: {
      if (action.payload.method === 'ADD') {
        return {
          ...state,

          events: {
            data: action.payload.data
            // pagination: action.payload.data.pagination
          }
        }
      }

      if (action.payload.method === 'CLEAR') {
        return {
          ...state,

          events: {
            data: [],
            pageCount: 0
          }
        }
      }
    }

    case UPDATE_ZOOM_COURSE_ID: {
      return {
        ...state,

        courseId: action.payload
      }
    }

    case UPDATE_ZOOM_COURSE_DETAILS: {
      return {
        ...state,

        courseDetails: action.payload
      }
    }

    case UPDATE_ZOOM_HOST: {
      return {
        ...state,
        zoomHost: action.payload.zoomHost,
        coHost: action.payload.zoomCoHost
      }
    }

    case UPDATE_SELECTED_ZOOM_EVENTS: {
      return {
        ...state,

        selectedEventIds: {
          data: action.payload
        }
      }
    }

    case UPDATE_ZOOM_SCHEDULERS: {
      return {
        ...state,

        schedulers: {
          data: action.payload
        }
      }
    }

    default:
      return state
  }
}
